<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-2xl font-bold">{{ title }}</h2>
      <Button v-if="showAddButton" @click="$emit('add-user')" label="Adicionar Usuário" severity="primary" />
    </div>
    <DataTable :value="users" stripedRows paginator :rows="10">
      <Column field="first_name" header="Nome" sortable />
      <Column field="last_name" header="Sobrenome" sortable />
      <Column field="email" header="Email" sortable />
      <Column field="inserted_at" header="Criado em" sortable>
        <template #body="{ data }">
          {{ formatDate(data.inserted_at) }}
        </template>
      </Column>
      <Column field="inserted_by" header="Inserido por" sortable />
      <Column field="last_login_at" header="Último Login" sortable>
        <template #body="{ data }">
          {{ formatDate(data.last_login_at) }}
        </template>
      </Column>
      <Column field="is_account_admin" header="Administrador" sortable>
        <template #body="{ data }">
          <span class="material-icons" :class="data.is_account_admin ? 'text-green-600' : 'text-gray-400'">
            {{ data.is_account_admin ? 'check_circle' : 'cancel' }}
          </span>
        </template>
      </Column>
      <Column field="role.name" header="Papel" sortable>
        <template #body="{ data }">
          <span v-if="data.role" class="px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
            {{ data.role.name }}
          </span>
          <span v-else class="text-gray-400 italic text-xs">Sem papel</span>
        </template>
      </Column>
      <Column v-if="showActions" header="Ações">
        <template #body="{ data }">
          <Button @click="$emit('edit-user', data)" class="mr-2" severity="secondary">
            <template #icon><span class="material-icons">edit</span></template>
          </Button>
          <Button v-if="showDeleteButton" @click="$emit('delete-user', data)" severity="danger">
            <template #icon><span class="material-icons">delete</span></template>
          </Button>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import type { User } from '@/types/user';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { formatDate } from '@/utils/formatters';

defineProps<{
  title: string;
  users: User[];
  showAddButton: boolean;
  showActions: boolean;
  showDeleteButton: boolean;
}>();

defineEmits(['add-user', 'edit-user', 'delete-user']);
</script>
